import "./footer.css";
import GoogleButton from "../googleButton/googleButton.jsx";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-grid">
          <section className="footer-col services">
            <h2>Popular Services</h2>
            <ul>
              <li>Assembly & Installation</li>
              <li>Patching & Painting</li>
              <li>Fence Painting</li>
              <li>Carpentry Services</li>
              <li>Plastering Service</li>
              <li>General Handyman</li>
              <li>Commercial Maintenance</li>
              <li>Real Estate Maintenance</li>
            </ul>
          </section>
          
           <section className="footer-col">
            <h2>Service Areas</h2>
            <p style={{marginBottom: '6px'}}>Based in <strong>Oakleigh</strong>.</p>
            <p style={{marginBottom: '6px'}}>Servicing a 30km radius.</p>
            <p style={{marginBottom: '6px'}}>Find out in our full area list above.</p>
            <p>Not sure? Ask us anyway.</p>
          </section>

          <section className="footer-col">
            <h2>Request a Fix</h2>
            <a href="tel:0412279273" className="link">0412 279 273</a>
            <a href="mailto:info@handymaninmelbourne.au" className="link">info@handymaninmelbourne.au</a>
            <p>Mon - Fri: 8am - 5pm</p>
            <p>Sat: 9am - 3pm</p>
            <img src="/static/images/branding/handyman-in-melbourne-logo.png" alt="Handyman In Melbourne logo" />

            <GoogleButton />
          </section>
        </div>

        <hr />

        <div className="network-bar">
          <span>Our Network:</span>
          <a href="https://guttercleaninginmelbourne.com.au" target="_blank" rel="noopener noreferrer" className="link">Gutter Cleaning In Melbourne</a>
          <a href="https://interior4u.com.au" target="_blank" rel="noopener noreferrer" className="link">Interior 4U</a>
          <div className="social-container">
            <span>Follow us:</span>
            <div className="social-icons">
              <a
                href="https://www.instagram.com/handymaninmelbourne"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Follow Handyman In Melbourne on Instagram (opens in a new tab)"
              >
                <svg className="social-icon instagram-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                  <defs>
                    <linearGradient id="instagram-gradient" x1="0%" y1="100%" x2="100%" y2="0%">
                      <stop offset="0%" stopColor="#feda75" />
                      <stop offset="35%" stopColor="#fa7e1e" />
                      <stop offset="65%" stopColor="#d62976" />
                      <stop offset="100%" stopColor="#4f5bd5" />
                    </linearGradient>
                  </defs>
                  <rect x="3" y="3" width="18" height="18" rx="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle className="instagram-dot" cx="17.5" cy="6.8" r="1" />
                </svg>
                <span className="social-link-label">Instagram</span>
              </a>
            </div>
          </div>
        </div>

        <p className="copyright footer-legal">
          © Copyright 2026 Handyman In Melbourne All Rights Reserved  <a href="/terms-and-conditions"> Terms and Conditions</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
